module.exports = __webpack_public_path__ + "img/syriatel.9193f86f.png";